import Layout from '@layout/Index'

export const userCover = [
  {
    path: '/user-cover',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "user-cover-table" */ './pages/UserCoverTable.vue'),
        name: '覆盖查询列表',
        meta: {
          title: '覆盖查询列表',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/user-cover/user-cover.route.js